/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_PresetsInputs */

const en_export_presets = /** @type {(inputs: Export_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Presets`)
};

const fr_export_presets = /** @type {(inputs: Export_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter les préréglages`)
};

const de_export_presets = /** @type {(inputs: Export_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export-Voreinstellungen`)
};

const it_export_presets = /** @type {(inputs: Export_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione dei preset`)
};

const ru_export_presets = /** @type {(inputs: Export_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт предустановок`)
};

const es_export_presets = /** @type {(inputs: Export_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar ajustes preestablecidos`)
};

const zh_cn2_export_presets = /** @type {(inputs: Export_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出预设`)
};

const ja_export_presets = /** @type {(inputs: Export_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートプリセット`)
};

const hi_export_presets = /** @type {(inputs: Export_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट निर्यात करें`)
};

const pt_pt2_export_presets = /** @type {(inputs: Export_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinições de exportação`)
};

/**
* | output |
* | --- |
* | "Export Presets" |
*
* @param {Export_PresetsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const export_presets = /** @type {((inputs?: Export_PresetsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_PresetsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_export_presets(inputs)
	if (locale === "de") return de_export_presets(inputs)
	if (locale === "it") return it_export_presets(inputs)
	if (locale === "ru") return ru_export_presets(inputs)
	if (locale === "es") return es_export_presets(inputs)
	if (locale === "zh-CN") return zh_cn2_export_presets(inputs)
	if (locale === "ja") return ja_export_presets(inputs)
	if (locale === "hi") return hi_export_presets(inputs)
	if (locale === "pt-PT") return pt_pt2_export_presets(inputs)
	return en_export_presets(inputs)
});